import {
  EDIT_QUESTION,
  EDIT_QUESTION_SUCCESS,
  EDIT_QUESTION_CLEAN,
  EDIT_QUESTION_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  question: undefined,
}

const QuestionEdit = (state = initialState, action) => {
  switch (action.type) {
    case EDIT_QUESTION:
      state = {
        ...state,
        loading: true,
      }
      break
    case EDIT_QUESTION_SUCCESS:
      state = {
        ...state,
        question: action.payload.question,
        loading: false,
        done: true,
      }
      break
    case EDIT_QUESTION_CLEAN:
      state = initialState
      break
    case EDIT_QUESTION_ERROR:
      state = { ...state, error: action.payload, loading: false, done: true }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default QuestionEdit
